module.exports = __webpack_public_path__ + "media/images/nic-9a7b0ff30a6ad45c98e1985f8f47e295.png";